const DEFAULT_MAX_SIDE = 2000;
const DEFAULT_QUALITY = 0.82;

const readFileAsDataUrl = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = () => reject(new Error('Не удалось прочитать фото'));
  reader.readAsDataURL(file);
});

const loadImage = (src) => new Promise((resolve, reject) => {
  const image = new Image();
  image.onload = () => resolve(image);
  image.onerror = () => reject(new Error('Не удалось обработать фото'));
  image.src = src;
});

const canvasToBlob = (canvas, quality) => new Promise((resolve, reject) => {
  canvas.toBlob((blob) => {
    if (!blob) {
      reject(new Error('Не удалось сжать фото'));
      return;
    }
    resolve(blob);
  }, 'image/jpeg', quality);
});

const getScaledSize = (width, height, maxSide) => {
  const longestSide = Math.max(width, height);
  if (longestSide <= maxSide) {
    return { width, height };
  }

  const scale = maxSide / longestSide;
  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale)),
  };
};

const buildCompressedFileName = (originalName) => {
  const safeBase = String(originalName || 'photo')
    .replace(/\.[^.]+$/, '')
    .trim() || 'photo';
  return `${safeBase}.jpg`;
};

export async function compressImageFile(file, options = {}) {
  if (!(file instanceof File)) {
    return file;
  }

  if (!String(file.type || '').startsWith('image/')) {
    return file;
  }

  const maxSide = Number(options.maxSide) || DEFAULT_MAX_SIDE;
  const quality = Number(options.quality) || DEFAULT_QUALITY;

  try {
    const src = await readFileAsDataUrl(file);
    const image = await loadImage(src);
    const { width, height } = getScaledSize(image.naturalWidth || image.width, image.naturalHeight || image.height, maxSide);

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext('2d', { alpha: false });
    if (!context) {
      return file;
    }

    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, width, height);
    context.drawImage(image, 0, 0, width, height);

    const blob = await canvasToBlob(canvas, quality);
    if (blob.size >= file.size && (image.naturalWidth || image.width) <= maxSide && (image.naturalHeight || image.height) <= maxSide) {
      return file;
    }

    return new File([blob], buildCompressedFileName(file.name), {
      type: 'image/jpeg',
      lastModified: Date.now(),
    });
  } catch {
    return file;
  }
}
